import { useState, useEffect } from 'react';
import { ShoppingBag } from 'lucide-react';
import { getMediaUrl } from '../api/client.js';

interface ProductImageProps {
  src?: string | null;
  alt: string;
  className?: string;
  fallbackIconClassName?: string;
  fallbackIcon?: React.ReactNode;
  loading?: 'lazy' | 'eager';
}

export function ProductImage({
  src,
  alt,
  className = 'w-full h-full object-cover',
  fallbackIconClassName = 'w-8 h-8 opacity-40',
  fallbackIcon,
  loading = 'lazy',
}: ProductImageProps) {
  const [hasError, setHasError] = useState(false);

  // Reset error state when src changes
  useEffect(() => {
    setHasError(false);
  }, [src]);

  const resolvedUrl = getMediaUrl(src);

  if (!resolvedUrl || hasError) {
    if (fallbackIcon) {
      return <>{fallbackIcon}</>;
    }
    return <ShoppingBag className={fallbackIconClassName} />;
  }

  return (
    <img
      src={resolvedUrl}
      alt={alt}
      loading={loading}
      className={className}
      onError={() => setHasError(true)}
    />
  );
}
